// extracted by mini-css-extract-plugin
export default {"searchArea":"searchField_searchArea__julRE","dateField":"searchField_dateField__mbWKZ"};